import { Directive, HostListener, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { SubscriptionPlan } from '@vi-iot/client';

import { CancelBookingModalComponent } from '../../components/cancel-booking-modal/cancel-booking-modal.component';

@Directive({
  selector: '[appCancelBooking]',
  standalone: true,
})
export class CancelBookingDirective {
  cancelBookingModalRef: MatDialogRef<CancelBookingModalComponent>;

  @Input() boilerId: string;
  @Input() companyId: string;
  @Input() isFlatRate = false;
  @Input() subscriptionPlan: SubscriptionPlan;

  @HostListener('click')
  onClick(): void {
    this.cancelBookingModalRef = this.matDialog.open(CancelBookingModalComponent, {
      width: '552px',
      panelClass: 'cancel-booking-dialog',
      disableClose: true,
      data: {
        boilerId: this.boilerId,
        companyId: this.companyId,
        isFlatRate: this.isFlatRate,
        subscriptionPlan: this.subscriptionPlan,
      },
    });
  }

  constructor(private matDialog: MatDialog) {}
}
